module.exports = __webpack_public_path__ + "img/escs.89cd99cf.png";